<!-- NO FILTERS -->
<ng-template #noFilters>
  <p class="fx--label">No Filters found.</p>
</ng-template>

<!-- FILTERS CONFIGURED -->
<ng-container *ngIf="form; else noFilters">
  <form [formGroup]="form" class="fx fx--v">
    <div id="e2e-cbrefilters" class="fx--h fx--wrap filters filters__gap">
      <ng-container *ngFor="let filter of filters$(); let i = index">
        <!-- single -->
        <ng-container *ngIf="filter.type !== 'group' && filter.associations == null">
          <div
            id="e2e-cbrefilter-{{ i + 1 }}"
            class="fx--v filter"
            [ngClass]="{ filter__double: filter.type === 'range' }"
          >
            <cbre-filter
              [form]="form"
              [filter]="filter"
              [aggregations]="aggregations"
              [canRemoveFilter]="filter.closeIcon"
              (removeFilter)="removeFilter.emit($event)"
              (filterOptionChange)="onFilterOptionChange($event)"
            >
            </cbre-filter>
          </div>
        </ng-container>

        <!-- group -->
        <ng-container *ngIf="filter.type === 'group' && filter?.associations.length > 0">
          <div
            class="fx--h filter filters__gap"
            [ngClass]="filter.selectItemsInGroup ? 'filter__full-row' : 'filter__group-double'"
          >
            <cbre-filter-group
              [form]="form"
              [filter]="filter"
              [aggregations]="aggregations"
              [canRemoveFilter]="filter.closeIcon"
              (removeFilter)="removeFilter.emit($event)"
              (filterOptionChange)="onFilterOptionChange($event)"
            >
            </cbre-filter-group>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </form>
</ng-container>
